import { render, staticRenderFns } from "./comment-user-name.vue?vue&type=template&id=6e9bd37e&"
import script from "./comment-user-name.vue?vue&type=script&lang=js&"
export * from "./comment-user-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports